export const prefix = "bat"
export const iconName = "bold"
export const width = 12
export const height = 16
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M9.22464 7.6543C10.229 6.96059 10.933 5.82166 10.933 4.76557C10.933 2.4256 9.1211 0.624023 6.79148 0.624023H0.320312V15.1194H7.60943C9.77339 15.1194 11.4507 13.3593 11.4507 11.1953C11.4507 9.62153 10.5603 8.27553 9.22464 7.6543ZM3.42647 3.21249H6.53263C7.392 3.21249 8.08571 3.9062 8.08571 4.76557C8.08571 5.62494 7.392 6.31865 6.53263 6.31865H3.42647V3.21249ZM7.05033 12.531H3.42647V9.42481H7.05033C7.9097 9.42481 8.60341 10.1185 8.60341 10.9779C8.60341 11.8373 7.9097 12.531 7.05033 12.531Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batBold = definition
